import { render, staticRenderFns } from "./ModelingRules.vue?vue&type=template&id=628af7d1&scoped=true&"
import script from "./ModelingRules.vue?vue&type=script&lang=js&"
export * from "./ModelingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628af7d1",
  null
  
)

export default component.exports